/**
 * Booking business rule constants.
 *
 * Single source of truth for magic numbers previously scattered
 * across ReservationForm.vue, FilterForm.vue, and HomeSearch.vue.
 */

// Hours buffer: if current time is within this many hours of closing, today is disabled
export const PAST_BOOKING_BUFFER_HOURS = 2;

// When next-morning prevention fires, the earliest allowed start hour
export const NEXT_MORNING_EARLIEST_HOUR = 10;

// Threshold (in hours diff) for next-morning prevention:
// if serverTime.diff(dayStart) > this value, prevention kicks in
export const NEXT_MORNING_THRESHOLD_HOURS = -16;

// Minimum gap between start and end hour on the same day
export const SAME_DAY_END_HOUR_OFFSET = 1;

// Debounce delay for voucher input before triggering price recalculation
export const VOUCHER_DEBOUNCE_MS = 800;

// Max valid hour value (used for clamping)
export const MAX_HOUR = 24;

// Datepicker locale map
import { en, es, de } from 'vuejs-datepicker/dist/locale';
export const DATEPICKER_LOCALES = { en, es, de };
